import { MessageCircle, ChevronDown } from "lucide-react";

const WA_LINK = "https://wa.me/5491165162564?text=Hola%2C%20quiero%20hacer%20una%20consulta%20contable.";

export const Hero = () => {
  const scrollToServices = (e) => {
    e.preventDefault();
    const el = document.querySelector("#servicios");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative flex min-h-[90vh] items-center overflow-hidden md:min-h-screen"
    >
      <div className="absolute inset-0">
        <img
          src="/images/hero_image.webp"
          alt="Bárbara Cargnello, contadora pública online para emprendedores y monotributistas"
          loading="eager"
          fetchpriority="high"
          width="1920"
          height="1080"
          className="h-full w-full object-cover object-[74%_center] md:object-center"
        />
        <div className="absolute inset-0 bg-navy-900/70" />
      </div>

      <div className="relative z-10 container mx-auto max-w-7xl px-4 pt-20 md:px-6">
        <div className="max-w-3xl">
          <div
            className="mb-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 backdrop-blur-sm animate-fade-in"
            style={{ animationDelay: "0.1s" }}
          >
            <span className="h-2 w-2 rounded-full bg-gold" />
            <span className="font-inter text-sm text-cream-200">
              Estudio contable online, moderno y 100% digital
            </span>
          </div>

          <h1
            className="mb-6 font-poppins text-4xl font-bold leading-tight text-white animate-fade-in-up sm:text-5xl lg:text-6xl"
            style={{ animationDelay: "0.2s" }}
          >
            Bárbara Cargnello{" "}
            <span className="text-gold">Contadora Pública</span>
          </h1>

          <p
            className="mb-3 max-w-2xl font-inter text-base leading-relaxed text-cream-200 animate-fade-in-up md:text-lg"
            style={{ animationDelay: "0.4s" }}
          >
            Brindamos soluciones contables e impositivas de manera ágil y
            personalizada para emprendedores, profesionales y empresas.
          </p>
          <p
            className="mb-10 max-w-2xl font-inter text-sm leading-relaxed text-cream-300/80 animate-fade-in-up md:text-base"
            style={{ animationDelay: "0.5s" }}
          >
            Servicio remoto, gestión digital eficiente y acompañamiento
            profesional para mantener tus impuestos al día.
          </p>

          <div
            className="flex flex-col gap-4 animate-fade-in-up sm:flex-row"
            style={{ animationDelay: "0.6s" }}
          >
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              aria-label="Consultar con contadora por WhatsApp"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-whatsapp px-8 py-4 font-poppins text-base font-medium text-black shadow-lg shadow-whatsapp/25 transition-all duration-200 hover:scale-105 hover:brightness-110"
            >
              <MessageCircle className="h-5 w-5" />
              Consultar por WhatsApp
            </a>
            <a
              href="#servicios"
              onClick={scrollToServices}
              data-testid="hero-services-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/30 px-8 py-4 font-poppins text-base font-medium text-white transition-all duration-200 hover:bg-white/10"
            >
              Ver servicios
            </a>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 hidden -translate-x-1/2 animate-bounce md:block">
          <ChevronDown className="h-6 w-6 text-white/50" />
        </div>
      </div>
    </section>
  );
};

